import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useUpdateSubscriptionMutation } from 'api/main';
import { getRenderRoleName } from 'utils/helpers';
import { useUserAvailableRoles } from '../hooks';
import { texts } from 'utils/languages/fr';

import { ActionButton, CancelButton, CustomDialogTitle, CustomSelect } from 'components';
import { Dialog, DialogActions, DialogContent, MenuItem } from '@mui/material';

const renderRole = role => (
    <MenuItem key={role.id} value={role.id}>
        {getRenderRoleName(role)}
    </MenuItem>
);

const RoleChangeDialog = ({ onClose, user, open }) => {
    const [updateSubscription, { isLoading, isSuccess }] = useUpdateSubscriptionMutation();

    const [selectedRole, setSelectedRole] = useState('');
    const [error, setError] = useState('');

    const userSubscription = user.subscriptions[0];
    const availableRoles = useUserAvailableRoles(userSubscription);

    const handleChange = useCallback(e => {
        setSelectedRole(+e.target.value);
    }, []);

    const handleConfirm = useCallback(() => {
        if (!selectedRole) {
            setError(texts.CHOISIR_OPTION);
            return;
        }
        setError('');
        updateSubscription({ id: userSubscription.id, role: `api/roles/${selectedRole}` });
    }, [updateSubscription, selectedRole, userSubscription]);

    useEffect(() => {
        if (userSubscription) {
            setSelectedRole(userSubscription?.role?.id);
        }
    }, [userSubscription]);

    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);

    return (
        <Dialog open={open} onKeyDown={e => e.stopPropagation()}>
            <CustomDialogTitle title={texts.CHANGE_ROLE} handleClose={isLoading ? null : onClose} />
            <DialogContent>
                <CustomSelect
                    label={texts.SELECTIONNEZ_LE_ROLE}
                    value={selectedRole}
                    onChange={handleChange}
                    error={error}
                    helperText={error}
                >
                    {availableRoles.map(renderRole)}
                </CustomSelect>
            </DialogContent>
            <DialogActions>
                <CancelButton disabled={isLoading} onClick={onClose}>
                    {texts.CANCEL}
                </CancelButton>
                <ActionButton
                    size="small"
                    sx={{ padding: '3px 5px' }}
                    loading={isLoading}
                    disabled={isLoading}
                    onClick={handleConfirm}
                >
                    {texts.CONFIRMER}
                </ActionButton>
            </DialogActions>
        </Dialog>
    );
};

RoleChangeDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool,
    user: PropTypes.object,
};

export default RoleChangeDialog;
